import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaRegHeart } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { auth } from "../firebase/firebaseconfig";
import { query, where, getDocs, collection, doc, updateDoc, addDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseconfig";
import { addToWishlist } from "../GlobalStates/WishlistService";

import { useGlobal } from "../App";
import { getBestCategoryDiscount } from "../utils/discounts";

export default function Productslider({ products, category }) {
  const sliderwrapper = useRef(null);
  const { coupons, showNotification } = useGlobal();

  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");

  const scrollswiper = (amount) => {
    sliderwrapper.current.scrollBy({
      left: amount,
      behavior: "smooth",
    });
  };

  const user = auth.currentUser;

  useEffect(() => {
    if (user) {
      console.log("logged in " + user.email);
    } else {
      console.log("Not logged in");
    }
  }, [user]);

  // Click tracking function
  const trackProductClick = async (product) => {
    console.log("🔥 Productslider trackProductClick called for product:", product.name);
    try {
      const clickData = {
        productName: product.name,
        productId: product.id,
        username: user ? user.email : "Anonymous",
        timestamp: new Date().toISOString(),
        page: window.location.pathname
      };

      console.log("📝 Productslider attempting to add click data:", clickData);
      await addDoc(collection(db, "clicks"), clickData);
      console.log("✅ Productslider click tracked successfully:", clickData);
    } catch (error) {
      console.error("❌ Productslider error tracking click:", error);
      console.error("Error details:", error.message);
    }
  };

  const addtocart = async (product, e) => {
    e.stopPropagation();

    // ✅ Store only productId, quantity, size (Best Practice)
    let cartItem = {
      productId: product.id,
      quantity: 1,
      size: null,
    };

    if (user?.email) {
      const q = query(
        collection(db, "Users"),
        where("User", "==", user.email)
      );

      const currentuser = await getDocs(q);
      if (currentuser.empty) return;

      const userDoc = currentuser.docs[0];
      const userData = userDoc.data();
      const userId = userDoc.id;

      let updatedCart = Array.isArray(userData.cart) ? [...userData.cart] : [];

      const existingIndex = updatedCart.findIndex(
        item =>
          item.productId === cartItem.productId &&
          item.size === cartItem.size
      );

      if (existingIndex !== -1) {
        updatedCart[existingIndex].quantity += cartItem.quantity;
      } else {
        updatedCart.push(cartItem);
      }

      await updateDoc(doc(db, "Users", userId), {
        cart: updatedCart,
      });
    } else {
let cart = [];
try {
  const raw = localStorage.getItem("cart");
  cart = raw ? JSON.parse(raw) : [];
} catch (error) {
  console.error("Failed to parse cart from localStorage, resetting cart:", error);
  cart = [];
}
      const existingIndex = cart.findIndex(
        item =>
          item.productId === cartItem.productId &&
          item.size === cartItem.size
      );

      if (existingIndex !== -1) {
        cart[existingIndex].quantity += cartItem.quantity;
      } else {
        cart.push(cartItem);
      }
      localStorage.setItem("cart", JSON.stringify(cart));
      console.log("Cart updated in localStorage:", cart);
    }

    // success message
    let productDiv = e.currentTarget;
    while (productDiv && !productDiv.classList.contains("product")) {
      productDiv = productDiv.parentElement;
    }

    if (productDiv) {
      const addedDiv = productDiv.querySelector(".added");
      if (addedDiv) {
        addedDiv.classList.add("active");
        setTimeout(() => addedDiv.classList.remove("active"), 2000);
      }
    }

    // also fire global toast
    if (showNotification) {
      showNotification("Item added to cart");
    }
  };

  if (!Array.isArray(products) || products.length === 0) return null;

  return (
    <div className="slider d-flex flex-column mt-3">
      {/* Header */}
      <div className="w-100 d-flex justify-content-between px-4 maxw">
        <h1>{category}</h1>

        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-2">
            <button className="pagination" onClick={() => scrollswiper(-1000)}>
              <IoIosArrowBack />
            </button>
            <button className="pagination" onClick={() => scrollswiper(1000)}>
              <IoIosArrowForward />
            </button>
          </div>

          <Link
            to={`/category/${category.toLowerCase()}`}
            className="m-0 border-0 bg-transparent navlink"
          >
            View all
          </Link>
        </div>
      </div>

      {/* Products */}
      <div className="Productslider maxw" ref={sliderwrapper}>
        {products.map((product) => (
          <div 
            className="product gap-3" 
            key={product.id} 
            data-product-name={product.name} 
            data-product-id={product.id}
          >
            <div className="added">item Added To Cart Successfully</div>

            {/* IMAGE ONLY */}
            <div className="imgcontainer">
              <Link
                to={`/products/${slugify(product.name)}`}
                className="navlink"
                onClick={(e) => {
                  trackProductClick(product);
                  // Don't prevent default - allow navigation
                }}
              >
                <img src={product.imageUrl || product.image} alt={product.name} />
              </Link>
            </div>

            {/* ACTIONS */}
            <div className="hover-actions">
              {product.inStock === false ? (
             <></>
              ) : product.category?.toLowerCase() === "frames" ? (
                <Link
                  to={`/products/${slugify(product.name)}`}
                  className="addtocarthvrbtn"
                >
                  Choose size
                </Link>
              ) : (
                <button
                  className="addtocarthvrbtn"
                  onClick={(e) => addtocart(product, e)}
                >
                  + Add to Cart
                </button>
              )}

              <button
                className="addtowshlsthvrbtn"
                onClick={async (e) => {
                  e.stopPropagation();
                  try {
                    await addToWishlist(product, user);
                    // show temporary confirmation style similar to cart
                    let prodDiv = e.currentTarget;
                    while (prodDiv && !prodDiv.classList.contains("product")) {
                      prodDiv = prodDiv.parentElement;
                    }
                    if (prodDiv) {
                      const wishDiv = prodDiv.querySelector(".wadded");
                      if (wishDiv) {
                        wishDiv.classList.add("active");
                        setTimeout(() => wishDiv.classList.remove("active"), 2000);
                      }
                    }
                    if (showNotification) {
                      showNotification("Item added to wishlist");
                    }
                  } catch (err) {
                    console.error("Error adding to wishlist", err);
                  }
                }}
              >
                <FaRegHeart /> Add to Wishlist
              </button>
            </div>

            {/* TITLE + PRICE + BUTTON */}
<div className="product-info">

  <Link
    to={`/products/${slugify(product.name)}`}
    className="navlink"
    onClick={(e) => {
      trackProductClick(product);
      // Don't prevent default - allow navigation
    }}
  >
    <h5 >{product.name}   {product.inStock === false && (
    <span className="badge bg-danger" style={{ marginBottom: "6px" }}>
      Out of stock
    </span>
  )}</h5>
  </Link>


  <div className="product-footer">
          <p>
            {product.category === 'Frames' ? `From ${product.smallframeprice} LE ` : `${product.price} LE`}


          </p>

    {product.inStock === false ? (
    <></>
    ) : product.category?.toLowerCase() === "frames" ? (
      <Link
        to={`/products/${slugify(product.name)}`}
        className="addtocarthvrbtn"
        onClick={(e) => {
          trackProductClick(product);
          // Don't prevent default - allow navigation
        }}
      >
        Choose size
      </Link>
    ) : (
      <button
        className="addtocarthvrbtn"
        onClick={(e) => {
          trackProductClick(product);
          addtocart(product, e);
        }}
      >
        + Add to Cart
      </button>
    )}
  </div>

     {product.inStock === false ? (
      <button    className="btn w-100 mt-2 fw-bold  hideonbigscreent"
                      style={{
                        backgroundColor: "#1f2730",
                        color: "#f2d5bd",
                        border: "none"
                      }} disabled>
        Out of stock
      </button>
    ) : product.category?.toLowerCase() === "frames" ? (
      <Link
        to={`/products/${slugify(product.name)}`}
   className="btn w-100 mt-2 fw-bold  hideonbigscreent"
                      style={{
                        backgroundColor: "#1f2730",
                        color: "#f2d5bd",
                        border: "none"
                      }}
        onClick={(e) => {
          trackProductClick(product);
          // Don't prevent default - allow navigation
        }}
      >
        Choose size
      </Link>
    ) : (
      <button
   className="btn w-100 mt-2 fw-bold  hideonbigscreent"
                      style={{
                        backgroundColor: "#1f2730",
                        color: "#f2d5bd",
                        border: "none"
                      }}
        onClick={(e) => {
          trackProductClick(product);
          addtocart(product, e);
        }}
      >
        + Add to Cart
      </button>
    )}

</div>

          </div>
        ))}
      </div>
    </div>
  );
}
